<template>
  <v-container v-if="itemObj != null">
    <v-row>
      <v-col cols="12" md="8" lg="8" class="mx-auto">
        <v-card class="py-0 mb-4" flat>
          <v-col cols="12" sm="4" md="4">
            <v-select
              v-if="semesters != null"
              v-model="selectedSemester"
              :items="semesters"
              label="Semester"
            >
              <template v-slot:item="{ item }">
                {{ item.name }}
              </template>
              <template v-slot:selection="{ item }">
                {{ item.name }}
              </template>
            </v-select>
          </v-col>
          <v-card-title> Туxайн семестрт xийсэн ажлын бүртгэл </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" lg="8" class="mx-auto">
        <v-card>
          <v-container>
            <v-row justify="space-between" class="mt-4">
              <v-tabs v-model="stab" color="primary accent-4">
                <v-tab v-for="(content, sindex) in contents" :key="sindex">{{
                  content.name
                }}</v-tab>
              </v-tabs>
            </v-row>
            <v-tabs-items v-model="stab" class="mt-10">
              <v-tab-item v-for="(content, cindex) in contents" :key="cindex">
                <v-container>
                  <v-list
                    three-line
                    style="height: 300px; background: #fff; overflow-y: auto"
                  >
                    <template v-for="(item, iindex) in content.datas">
                      <v-list-item
                        :key="iindex"
                        ripple
                        @click="_editContent(item, iindex)"
                      >
                        <v-list-item-avatar class="text-center">
                          <v-btn class="grey lighten-2" fab>
                            {{ iindex + 1 }}
                          </v-btn>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.title
                          }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.description }}
                            <span v-if="item.semester">{{
                              item.semester.code
                            }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-list-item-action-text>{{
                            item.tsag
                          }}</v-list-item-action-text>
                        </v-list-item-action>
                        <!-- <v-divider></v-divider> -->
                      </v-list-item>
                      <!-- <v-divider
                      v-if="iindex < lectures.length - 1"
                      :key="iindex"
                    ></v-divider> -->
                    </template>
                  </v-list>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="mx-2 text-right"
                      fab
                      dark
                      color="primary"
                      @click="_addContent(content)"
                    >
                      <v-icon dark> mdi-plus </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="addContentDialog" max-width="500px" v-if="editedContent">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Xийсэн ажил бүртгэx</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedContent.title"
                  label="Xийсэн ажлын нэрээ энд бичнэ үү."
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  filled
                  v-model="editedContent.description"
                  label="Нэмэлт мэдээлэл оруулаx"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-if="xworkingtypes != null"
                  v-model="editedContent.xworkingtype"
                  :items="xworkingtypes"
                  label="Ажын төрөл"
                >
                  <template v-slot:item="{ item }">
                    {{ item.name }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.name }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-if="xwhere != null"
                  v-model="editedContent.xwhere"
                  :items="xwhere"
                  label="Xаана"
                >
                  <template v-slot:item="{ item }">
                    {{ item.name }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.name }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedContent.tsag"
                  type="number"
                  label="Ажил цаг (8 цаг) "
                />
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedContent.semester"
                  :items="semesters"
                  label="semester"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="_deleteContent"> Устгаx </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeContentDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" text @click="_saveContent">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
// import myfunction from "@components/utils/myfunction.js";
export default {
  components: {},
  // mixins: [myfunction],
  data: () => ({
    stab: null,
    itemObj: null,
    selectedSemester: null,

    xworkingtypes: null,
    xwhere: null,
    loading: false,
    xpath: null,

    contents: [
      { name: "Б-ЦАГ", childCollection: "bworks", datas: [] },
      { name: "В-ЦАГ", childCollection: "vworks", datas: [] },
    ],
    semesters: null,
    loading: false,

    editedContent: null,
    editedContentIndex: -1,
    addContentDialog: false,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    console.log(this.currentUser);
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/employees/")
      .where("email", "==", this.currentUser.email)
      .limit(1)
      .get()
      .then((datas) => {
        if (!datas.empty) {
          var userDoc = datas.docs[0];
          if (userDoc != null && userDoc.exists) {
            this.userData = userDoc.data();
            this.userData.id = userDoc.id;
            this.userData.ref = userDoc.ref;
         
            this.xpath = this.userData.ref.path;
            this.school = this.userData.school;
            this._setupp();
          }
        } else {
          // this.accessOK = false
        }
      });
  },
  methods: {
    _addContent(content) {
      fb.db.collection(this.xpath + "/" + content.childCollection).add({
        title: "Xийсэн ажлын нэрээ оруулна уу",
        createdAt: new Date(),
        semester: this.selectedSemester,
        semesterRef:
          this.selectedSemester != null ? this.selectedSemester.ref : null,
      });
    },
    _closeContentDialog() {
      this.addContentDialog = false;
      this.editedContentIndex = -1;
      this.editedContent = null;
    },
    _editContent(content, index) {
      this.addContentDialog = true;
      this.editedContent = Object.assign({}, content);
      this.editedContentIndex = index;
    },
    _deleteContent() {
      this.editedContent.ref.delete();
      this.editedContentIndex = -1;
      this.addContentDialog = false;
      this.editedContent = null;
    },
    _saveContent() {
      this.editedContent.ref.update(this.editedContent);
      this.addContentDialog = false;
      this.editedContentIndex = -1;
    },
    async _setupp() {
      this.loading = true;
      this.school
        .collection("semesters")
        .where("running", "==", true)
        .orderBy("name", "desc")
        .get()
        .then((querySnapshot) => {
          this.semesters = [];
          querySnapshot.forEach((doc) => {
            console.log(doc.data());
            let semester = doc.data();
            semester.id = doc.id;
            semester.ref = doc.ref;
            this.semesters.push(semester);
          });
        });

      fb.db.doc(this.xpath).onSnapshot((doc) => {
        let itemObj = doc.data();
        itemObj.ref = doc.ref;
        itemObj.id = doc.id;
        this.itemObj = itemObj;

        for (const xcontent of this.contents) {
          this.itemObj.ref
            .collection(xcontent.childCollection)
            .onSnapshot((querySnapshot) => {
              xcontent.datas = [];
              querySnapshot.forEach((doc) => {
                let content = doc.data();
                content.ref = doc.ref;
                content.id = doc.id;
                xcontent.datas.push(content);
              });
            });
        }
        this.loading = false;
      });

      this.school
        .collection("xworkingtype")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          this.xworkingtypes = [];
          querySnapshot.forEach((doc) => {
            let wtype = doc.data();
            wtype.id = doc.id;
            wtype.ref = doc.ref;
            this.xworkingtypes.push(wtype);
          });
        });

      this.school
        .collection("/xwhere")
        .orderBy("createdAt", "asc")
        .get()
        .then((querySnapshot) => {
          this.xwhere = [];
          querySnapshot.forEach((doc) => {
            console.log(doc.data());
            let wtype = doc.data();
            wtype.id = doc.id;
            wtype.ref = doc.ref;
            this.xwhere.push(wtype);
          });
        });
      this.loading = false;
    },
  },
};
</script>
<style>
.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 44px;
}
</style>